enum PreloaderTypeEnum {
  AUDIO = "Audio",
  BALL_TRIANGLE = "BallTriangle",
  BARS = "Bars",
  CIRCLES = "Circles",
  GRID = "Grid",
  HEARTS = "Hearts",
  OVAL = "Oval",
  PUFF = "Puff",
  RINGS = "Rings",
  SINNING_CIRCLES = "SpinningCircles",
  TAIL_SPIN = "TailSpin",
  THREE_DOTS = "ThreeDots"
}
export default PreloaderTypeEnum;
